import Image from 'next/image';
import styles from '../../styles/WacoSolarEclipse2024.module.scss';
import Link from 'next/link';
import { useRouter } from 'next/router';
import Head from 'next/head';
import { useScroll, useTransform } from 'framer-motion';

import { motion } from 'framer-motion';

export default function WacoSolarEclipse2024() {

  const router = useRouter();

  function handleRouting() {
    router.push({
      pathname: '/',
      query: { redirectPageCategory: 'Events' }
    })
  }

  const { scrollYProgress } = useScroll();
  const yRange = useTransform(scrollYProgress, [0, 1], [0, 1200]);

  return (
    <section id={styles.wrapper}>

      <Head>
        <title>The Waco 2024 Solar Eclipse | Celestial Event Info & Tickets</title>
        <meta name="description" content="Discover everything you need to know about the Waco April 8th, 2024 Solar Eclipse, from viewing locations to ticket sales. Prepare for a mesmerizing celestial event in Waco, Texas." />
      
        <link rel="apple-touch-icon" sizes="180x180" href="/v10-icons/apple-touch-icon.png?v=10" />
        <link rel="icon" type="image/png" sizes="32x32" href="/v10-icons/favicon-32x32.png?v=10" />
        <link rel="icon" type="image/png" sizes="16x16" href="/v10-icons/favicon-16x16.png?v=10" />
        <link rel="manifest" href="/v10-icons/site.webmanifest?v=10" />
        <link rel="mask-icon" href="/v10-icons/safari-pinned-tab.svg?v=10" color="#154734" />
        <link rel="shortcut icon" href="/v10-icons/favicon.ico?v=10" />
        <meta name="msapplication-TileColor" content="#da532c" />
        <meta name="msapplication-TileImage" content="/v10-icons/mstile-144x144.png?v=10" />
        <meta name="msapplication-config" content="/v10-icons/browserconfig.xml?v=10" />
        <meta name="theme-color" content="#154734" />
      
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0" />

      </Head>

      <motion.div style={{y: yRange}} id={styles.welcome}>
        <h1>Waco 2024 Solar Eclipse</h1>
        <Image sizes='auto auto' fill src='/Eclipse/waco-solar-eclipse-2024-tickets-events-info_bg.png' alt="Waco Total Solar Eclipse 2024 Tickets Events Info" />
      </motion.div>

      <div id={styles.info}>
        <div>
          <section>
            <h1>2024 Waco Solar Eclipse</h1>
            <p>
            In the heart of Texas, excitement is building as Waco prepares to play host to a celestial event,
            the total solar eclipse of 2024! On April 8th 2024 a spectacular total solar eclipse will pass right over Waco, Texas.
            This celestial event has a path that will move directly over Waco, making it a prime spot for visitors wanting to experience this celestial event fully.
            Looking to sell parking for the eclipse, or find parking in Waco and surrounding areas? Below below to get started
            </p>
            <button onClick={() => handleRouting()}>Find Tickets, Parking, & More</button>
          </section>

          <section>
            <Image sizes='auto auto' fill src='/Eclipse/waco-solar-eclipse-2024-tickets-events-info_a.jpg' alt="Waco Total Solar Eclipse 2024 Tickets Events Info" />
          </section>
        </div>
      </div>

      <div id={styles.info}>
        <div>
          <section>
            <h1>Where and When</h1>
            <p style={{fontSize: '1.55rem'}}>
            Waco offers a variety of viewing locations for experiencing the total solar eclipse.
            From parks and open spaces to scenic overlooks and riverbanks, residents and visitors alike will have ample opportunities to witness the celestial event.
            Cameron Park, with its sprawling greenery and panoramic views of the Brazos River,
            is a popular choice for eclipse viewing, providing a serene backdrop for this once-in-a-lifetime experience.
            The total solar eclipse will have a partial eclipse around 12:20pm and will move into totality from 1:38pm to 1:42pm allowing a full 4 minute experience.
            </p>
          </section>

          <section>
            <Image sizes='auto auto' fill src='/Eclipse/waco-solar-eclipse-2024-tickets-events-info_b.jpg' alt="Waco Total Solar Eclipse 2024 Tickets Events Info" />
          </section>
        </div>

      </div>
      
      <div id={styles.interactiveMap}>
        <h1>Solar Eclipse Map</h1>
        <div>
          <iframe loading="lazy" src="https://nso.edu/maps/eclipse_2024.html" frameBorder="0" height="100%" width="100%" data-rocket-lazyload="fitvidscompatible" data-lazy-src="https://nso.edu/maps/eclipse_2024.html" data-ll-status="loaded" class="entered lazyloaded" data-gtm-yt-inspected-8="true"></iframe>
        </div>
      </div>

      <div id={styles.info}>
        <div>
          <section>
            <h1 style={{fontSize: '3.6rem'}}>What is a total solar eclipse</h1>
            <p style={{fontSize: '1.3rem', lineHeight: '28px'}}>
            A total solar eclipse occurs when the moon passes directly between the Earth and the sun, temporarily blocking out the sun's light.
            This rare and mesmerizing event creates a path of totality where the sun is completely obscured,
            casting a shadow across a narrow strip of land or ocean. As the sky darkens, temperatures drop, and animals may exhibit unusual behaviors,
            culminating in a moment of eerie twilight just before totality. During totality, the sun's corona becomes visible,
            stretching out into space and offering people a unique opportunity to witness the sun's outer atmosphere.
            Whether you're a seasoned observer or a casual skywatcher, witnessing a total solar eclipse is an unforgettable experience
            that leaves a lasting impression on all who see it.
            </p>
            <h2>Additional Resources</h2>
            <span>
              <Link href="https://www.greatamericaneclipse.com/texas-2024-eclipse">GreatAmericanEclipse.com</Link>
              <Link href="https://eclipse2024.org/">Eclipse2024.com</Link>
            </span>
          </section>

          <section>
            <Image sizes='auto auto' fill src='/Eclipse/waco-solar-eclipse-2024-tickets-events-info_c.jpg' alt="Waco Total Solar Eclipse 2024 Tickets Events Info" />
          </section>
        </div>

      </div>

    </section>
  )
}
